import React from "react";

interface AlertProps {
    type: "error" | "success";
    message: string;
}

const AlertMessage: React.FC<AlertProps> = ({ type, message }) => {
    if (!message) return null;

    return (
        <div className={type === "error" ? "errorbar" : "successMessage"} style={{ marginTop: "20px" }}>
            <h3>{message}</h3>
        </div>
    );
};

export default AlertMessage;